export default __webpack_public_path__ + "static/fortnite-48fcea3823455e8081db0aa30bdec9ec.png";